gradientDirectiveModule = angular.module('gradient.setting', [])

gradientDirectiveModule.directive "gradientSetting", ["$window", "$timeout", "$compile", "$templateCache", ($window, $timeout, $compile, $templateCache) ->
  restrict: "A",
  scope: {data: "=ngModel", afterChange: '&'},
  templateUrl: "#{settingFolder}/gradient/template.jade"
  link: (scope, element, attrs, ngModel) ->

    calcAlphaHex = (opacity) ->
      if opacity == 1
        ''

      alpha = Math.floor(opacity * 255)
      hex = alpha.toString(16)

      if alpha < 16
        hex = '0' + hex

      return hex

    rgba2hex = (rgba) ->
      rgbaStringArray = rgba.match(/[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s]?([\d.]+)[\s+]?/g)
      if rgbaStringArray == null
        rgba
      else
        rgb = rgbaStringArray[0].split(', ')
        opacity = parseFloat(rgb[3])
        hexResult = if rgb and rgb.length == 4 then '#' + ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) + ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) else ''

        return hexResult + calcAlphaHex(opacity)

    hex2rgba = (hex) ->
      hex = hex.replace('#','')
      red = parseInt(hex.substring(0,2), 16)
      green = parseInt(hex.substring(2,4), 16)
      blue = parseInt(hex.substring(4,6), 16)
      alpha = parseInt(hex.substring(6,8), 16)
      if alpha
        alpha = Math.floor(alpha / 255 * 100)
      else
        alpha = 100

      return 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha / 100 + ')';

    generateBackgroundStyle = (colorStart, colorStop) ->
      colorStart = rgba2hex(colorStart);
      colorStop = rgba2hex(colorStop);
      scope.data.backgroundImage = "-webkit-linear-gradient(#{scope.direction}, #{colorStart} 0%, #{colorStop} 100%)"

    scope.gsettings = {}

    scope.timestamp = new Date().getTime()

    if scope.data.backgroundImage and scope.data.backgroundImage isnt "none"

      backgroundImage = scope.data.backgroundImage

      if backgroundImage.match(/-webkit-gradient/)
        fromColor = backgroundImage.match(/from\((.*)\),/)[1]
        toColor = backgroundImage.match(/to\((.*)\)\)/)[1]

        scope.positionStart = backgroundImage.split(", ")[1]
        scope.positionStop = backgroundImage.split(", ")[2]

        if scope.positionStart is "left top" and scope.positionStop is "right top"
          scope.direction = "left"
        else
          scope.direction = "top"
      else
        colors = backgroundImage.match(/(\w+),\s(\#.*)\s0%,\s(\#.*)\s100%/)
        scope.direction = colors[1]
        fromColor = hex2rgba(colors[2])
        toColor = hex2rgba(colors[3])

      console.log('colors: ', backgroundImage, fromColor, toColor, scope.direction)

      if scope.direction is "top"
        scope.position = "vertical"
      else
        scope.position = "horizontal"

      scope.gsettings.colorStart = fromColor
      scope.gsettings.colorStop = toColor

      scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop)

    listener0 = scope.$watch "position", (newVal, oldVal) ->
      return false if newVal is oldVal
      if newVal is "horizontal"
        scope.direction = 'left'
      else
        scope.direction = 'top'

      scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop)

    listener1 = scope.$watch "gsettings.colorStart", (newVal, oldVal) ->
      return false if newVal is oldVal
      scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop)

    listener2 = scope.$watch "gsettings.colorStop", (newVal, oldVal) ->
      return false if newVal is oldVal
      scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop)

    listener3 = scope.$watch "isGradient", (newVal, oldVal) ->
      return false if newVal is oldVal

      if newVal and (!scope.data.backgroundImage || scope.data.backgroundImage is "none")
        scope.gsettings.colorStart = "#c83636"
        scope.gsettings.colorStop = "#4cd132"
        scope.data.backgroundImage = generateBackgroundStyle(scope.gsettings.colorStart, scope.gsettings.colorStop)
      else
        scope.data.backgroundImage = "none"

    scope.isGradient = scope.data.backgroundImage and scope.data.backgroundImage isnt "none"

    scope.$on "$destroy", ->
      listener0()
      listener1()
      listener2()
      listener3()
]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/gradient/gradient.directive.coffee